import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import PostsType, {
  getCurrentPostsType,
  PostsTypeArr,
} from '../../defines/PostsType';
import PostServices from '../../services/PostServices';
import ImageStorage from '../../utils/ImageStorage';
import PostItem from './PostItem';

const NewsPage = () => {
  const postPerLoad = 5;
  const totalPage = 10;
  const pathName = useLocation().pathname;
  const postsType = getCurrentPostsType(pathName);
  const [currentPageIdx, setCurrentPageIdx] = useState<number>(1);
  const [posts, setPosts] = useState<any>([]);

  useEffect(() => {
    const getPosts = async () => {
      let from = (currentPageIdx - 1) * postPerLoad;
      const _posts = await PostServices.getPostByType(
        postsType.param,
        from,
        postPerLoad
      );
      if (_posts) {
        setPosts(_posts);
      }
    };
    getPosts();
  }, [currentPageIdx, pathName]);

  const handleClickPagination = (idx: number) => {
    setCurrentPageIdx(idx);
  };

  return (
    <>
      <div className='page-background'>
        <div className='sub-banner'>
          <div className='container mx-auto flex relative h-full overflow-y-visible overflow-x-visible'>
            <div className='banner-char'></div>
            <div className='banner-text'>
              <a className='home-button' href='/'>
                <img
                  src={ImageStorage.HomeButton}
                  alt='TOP 1 game quan đấu trên Zalo'
                />
              </a>
            </div>
          </div>
        </div>

        {/* SUBTABS */}
        <SubTabs pathName={pathName} />

        {/* POSTS */}
        <div className='sub-site-list pb-10'>
          <div className='container mx-auto'>
            {posts.map((post: any, index: number) => {
              return (
                <PostItem
                  key={index}
                  postId={post.postId}
                  postPath={`${postsType.path}/${post.path}`}
                  title={post.title}
                  desc={post.description}
                  thumbnail={post.thumbnail}
                  time={post.time}
                />
              );
            })}
          </div>
          {/* PAGINATION */}
          <Pagination
            currentPageIdx={currentPageIdx}
            totalPage={totalPage}
            onClickPage={handleClickPagination}
          />
        </div>
        <div className='recharge'>
          <a className='recharge-button' href='#'>
            <img
              src='/assets/images/button-recharge.0e2db18b.png'
              alt='Nạp thẻ'
            />
          </a>
        </div>
      </div>
    </>
  );
};

export default NewsPage;

const SubTabs = ({ pathName }: any) => {
  let content = [];
  if (window.innerWidth <= 1023) {
    content = PostsTypeArr.map((postType, index) => {
      return (
        <Link
          key={index}
          className={`tab ${postType.path === pathName ? 'active' : ''}`}
          to={postType.path}
        >
          {postType.name}
        </Link>
      );
    });
  } else {
    switch (pathName) {
      case PostsType.NEWS.path:
      case PostsType.EVENT.path:
        content.push(
          <Link
            key={1}
            className={`tab ${
              PostsType.NEWS.path === pathName ? 'active' : ''
            }`}
            to={PostsType.NEWS.path}
          >
            {PostsType.NEWS.name}
          </Link>
        );
        content.push(
          <Link
            key={2}
            className={`tab ${
              PostsType.EVENT.path === pathName ? 'active' : ''
            }`}
            to={PostsType.EVENT.path}
          >
            {PostsType.EVENT.name}
          </Link>
        );
        break;
      default:
        content.push(
          <Link
            key={1}
            className={`tab ${
              PostsType.FEATURE.path === pathName ? 'active' : ''
            }`}
            to={PostsType.FEATURE.path}
          >
            {PostsType.FEATURE.name}
          </Link>
        );
        content.push(
          <Link
            key={2}
            className={`tab ${
              PostsType.TUTORIAL.path === pathName ? 'active' : ''
            }`}
            to={PostsType.TUTORIAL.path}
          >
            {PostsType.TUTORIAL.name}
          </Link>
        );
        break;
    }
  }

  return <div className='sub-tabs'>{content}</div>;
};

interface PaginationProps {
  currentPageIdx: number;
  totalPage: number;
  onClickPage: (idx: number) => void;
}

const Pagination = ({
  currentPageIdx,
  totalPage,
  onClickPage,
}: PaginationProps) => {
  //
  const paginationArr = [];
  paginationArr.push(
    <li key={-1}>
      <div
        className='page-item page-item-active'
        onClick={() => {
          onClickPage(currentPageIdx - 1 > 1 ? currentPageIdx - 1 : 1);
        }}
      >
        &#60;
      </div>
    </li>
  );

  for (let i = 1; i <= totalPage; i++) {
    paginationArr.push(
      <li key={i}>
        <div
          className={`page-item
            ${i === currentPageIdx ? 'page-item-active' : ''}`}
          //
          onClick={() => {
            onClickPage(i);
          }}
        >
          {i}
        </div>
      </li>
    );
  }

  paginationArr.push(
    <li key={totalPage + 1}>
      <div
        className='page-item page-item-active'
        onClick={() => {
          onClickPage(
            currentPageIdx + 1 < totalPage ? currentPageIdx + 1 : totalPage
          );
        }}
      >
        &#62;
      </div>
    </li>
  );

  return (
    <div className='container mx-auto'>
      <ul className='pagination' id='pagination'>
        {paginationArr}
      </ul>
    </div>
  );
};
